<template>
  <div>
    <div ref="modal" style="display: none">
      <spinner-block v-model="dataProgress">
        <div v-if="data">
          <div class="mb-3">
            <div>
              <b>Изменение стоимости подписки</b>
            </div>
            Обратите внимание, это изменение заменит рассчитанную стоимость подписки, но не будет фактически
            списывать\возвращать деньги клиенту.
          </div>

          <gui-input type="number" v-model="data.need_paid" :error="dataError.need_paid" label="Стоимость подписки"/>


          <div class="mt-5">
            <button-save @click="save"/>
            <button-cancel @click="fancyboxClose"/>
          </div>
        </div>
      </spinner-block>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  data: function () {
    return {
      data: null,
      dataProgress: false,
      dataError: {
        need_paid: '',
      },
    }
  },
  props: {},
  mounted() {
  },
  methods: {
    loadData(id) {
      axiosGetValue('/api/admin/subscription/get', {id}, e => {
        this.data = e
      }, e => this.dataProgress = e)
    },
    openModal(data_id) {
      if (data_id)
        this.loadData(data_id)

      this.fancybox(this.$refs.modal, () => {
        this.data = null
        clearErrorList(this.dataError)
      });
    },
    save() {
      axiosFast({
        url: route('/api/admin/subscription/change-cost'),
        data: {id: this.data.id, need_paid: this.data.need_paid},
        error: this.dataError,
        progress: e => this.dataProgress = e,
        result: () => {
          toastSuccess('Данные сохранены');
          this.$emit('update')
          this.fancyboxClose();
        },
      })
    }
  }
}
</script>